import { type } from 'arktype'

export const allProducts = [
  'rcph',
  'muta',
  'rcda',
  'es-rcph',
  'rcpa',
  'rcpaxa',
  'fr-prel',
  'fr-rcpw',
  'nl-rcph',
  'mrph',
  'mrpw',
  'mrpa',
  'es-mrpw',
  'fr-rccw',
  'nl-aovql',
  'fr-aupa',
  'fr-mrga',
  'fr-mrpaxe',
  'fr-rcpaxe',
  'es-mrpaxe',
] as const
export const productSchema = type('===', ...allProducts)
export type Product = typeof productSchema.infer

/**
 * A browser tab keeps its frontend bundle for up to 24 hours after a deploy, while the backend is already newer. A value
 * typed `Product` that comes from the backend can therefore hold a product launched after this bundle was built.
 */
export function isKnownProduct(product: string): product is Product {
  return productSchema.allows(product)
}
